import { render, staticRenderFns } from "./CreateEmbrace.vue?vue&type=template&id=5e3b7f2a"
import script from "./CreateEmbrace.vue?vue&type=script&lang=js"
export * from "./CreateEmbrace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports